import { groupLifeService } from '@/services';
import type { GroupLifeSubmitAnalysisResponse } from '@/services/group-life';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type Variables = {
  policyId: string;
};

export function useSubmitGroupLifeAnalysisCalculation() {
  const queryClient = useQueryClient();

  return useMutation<GroupLifeSubmitAnalysisResponse, Error, Variables>({
    mutationKey: ['group-life', 'submit-analysis-calculation'],
    mutationFn: async ({ policyId }) => {
      const response = await groupLifeService.submitAnalysisCalculation(policyId);
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao aprovar cotação em análise');
      }
      return response.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['group-life', 'quote-details', variables.policyId],
      });
      queryClient.invalidateQueries({ queryKey: ['quotes'] });
      queryClient.invalidateQueries({ queryKey: ['quotes-status-count'] });
    },
  });
}
